import React from 'react';

import MessageItem from './message_item';

import type { Message } from './types';

interface Props {
  messages: Message[];
  showAdminDetails: boolean;
  speaking: boolean;
  onStopSpeaking: () => void;
}

export default function MessageList({ messages, showAdminDetails, speaking, onStopSpeaking }: Props) {
  return (
    <>
      {messages.map((message, index) => (
        <MessageItem
          key={index}
          message={message}
          showAdminDetails={showAdminDetails}
          showStopSpeaking={speaking && index === messages.length - 1}
          onStopSpeaking={onStopSpeaking}
        />
      ))}
    </>
  );
}
